// @ngInject
Filters.HbmarkerFilter  = function HbmarkerFilter($filter, $sce, UIUtils) {
    return function(text, class_name) {
        if (!class_name) {
            class_name = "hb-marker";
        }
        text = '<span class="' + class_name + '">' + UIUtils.sanitize(text) + '</span>';

        return $sce.trustAsHtml(text);
    };
};